var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168633",
    "data-name": "Group 168633",
    transform: "translate(-3291 20357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83260",
    "data-name": "Path 83260",
    d: "M40,0C71.046,0,80,8.954,80,40S71.046,80,40,80,0,71.046,0,40,8.954,0,40,0Z",
    transform: "translate(3291 -20357)",
    fill: "#ffe532"
  }), /*#__PURE__*/React.createElement("g", {
    id: "alert-circle",
    transform: "translate(3319 -20337)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_471",
    "data-name": "Line 471",
    y2: 14,
    transform: "translate(12 8)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_472",
    "data-name": "Line 472",
    x2: 0.01,
    transform: "translate(12 32)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.0b359dd0b6e6012c25bcedeecb775626.svg";
export { ForwardRef as ReactComponent };